import request from '@/utils/request';

// 1. 查询商店应用分类列表
export function fetchStoreAppClassificationList(params) {
  return request({
    url: '/ajax/enterprises/' + params.eid + '/app-types',
    method: 'get',
    params
  });
}

// 2. 添加应用分类
export function addStoreAppClassification(data) {
  return request({
    url: '/ajax/enterprises/' + data.eid + '/app-type',
    method: 'post',
    data: data
  });
}
// 3. 修改应用分类
export function upDateStoreAppClassificationInfo(data) {
  return request({
    url: '/ajax/enterprises/' + data.eid + '/app-type',
    method: 'PUT',
    data
  });
}

// 4. 删除应用分类
export function deleteStoreAppClassification(data) {
  return request({
    url: '/ajax/enterprises/' + data.eid + '/app-type/' + data.appTypeID,
    method: 'DELETE'
  });
}

// 5 查询商店应用分类
export function fetchStoreAppClassificationInfo(params) {
  return request({
    url: '/ajax/enterprises/' + params.eid + '/app-type/' + params.app_type_id,
    method: 'get'
  });
}



// WEBPACK FOOTER //
// ./src/api/appClassification.js